export const getDomElements = () => ({
	vatIncl: document.getElementById('vatIncl'),
	vatExcl: document.getElementById('vatExcl'),
	chamberId: document.getElementById('chamberOfCommerceId'),
	taxNumber: document.getElementById('companyTaxNumber'),
	taxNumberVatInput: document.getElementById('taxNumberVatInput'),
	translations: document.getElementById('chamberOfCommerceTranslations'),
	chamberInputWrapper: document
		.getElementById('chamberOfCommerceId')
		?.closest('.form-group'),
});

export default function registrationBillingForm(billingForm) {
	if (!billingForm) return;

	document.addEventListener('DOMContentLoaded', () => {
		const dom = getDomElements();

		if (!dom.taxNumber || !dom.chamberId) {
			return;
		}

		const countryCode = window?.dataLayer?.[0]?.navigation?.countryISO || '';

		if (dom.chamberId.value) {
			dom.taxNumber.value = `${countryCode}${dom.chamberId.value}`;
		} else if (!dom.taxNumber.value) {
			dom.taxNumber.value = `${countryCode}`;
		}

		let formValidator = null;
		const FormControl = window?.od?.FormControl;

		if (typeof FormControl === 'function') {
			formValidator = new FormControl(billingForm);
		}

		const handleVatChange = target => {
			const isMandatory = target.value === 'yes';

			if (dom.chamberInputWrapper) {
				dom.chamberInputWrapper.classList.toggle(
					'form-inline-row--is-mandatory',
					isMandatory,
				);
			}
			dom.taxNumberVatInput.toggleAttribute('hidden', !isMandatory);
			dom.taxNumber.name = isMandatory ? 'companyTaxNumber' : '';

			if (formValidator?.rules) {
				const fieldRules =
					formValidator.rules[dom.chamberId.name] ||
					(formValidator.rules[dom.chamberId.name] = {});

				if (isMandatory && dom.translations) {
					fieldRules.required = {
						rule: true,
						message: dom.translations.dataset.msgRequired,
					};
				} else {
					delete fieldRules.required;
				}
			}
		};

		if (dom.vatIncl?.checked) {
			handleVatChange(dom.vatIncl);
		} else if (dom.vatExcl?.checked) {
			handleVatChange(dom.vatExcl);
		}

		dom.vatIncl?.addEventListener('change', e => handleVatChange(e.target));
		dom.vatExcl?.addEventListener('change', e => handleVatChange(e.target));

		dom.chamberId.addEventListener('input', () => {
			if (countryCode) {
				dom.taxNumber.value = `${countryCode}${dom.chamberId.value}`;
			}
		});
	});
}
